import React, { useEffect, useState } from "react";

import {
    getColdOutreachDashboard,
    getColdOutreachHistory
} from "../services/api";

import DashboardStats from "../components/coldOutreach/DashboardStats";
import LatestCampaignCard from "../components/coldOutreach/LatestCampaignCard";
import AnalyticsListCard from "../components/coldOutreach/AnalyticsListCard";
import HistoryTable from "../components/coldOutreach/HistoryTable";
import CampaignTrendChart from "../components/coldOutreach/CampaignTrendChart";
import SuccessFailureChart from "../components/coldOutreach/SuccessFailureChart";

const ColdOutreachAnalytics = () => {
    const [dashboard, setDashboard] = useState(null);
    const [history, setHistory] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        loadDashboard();
    }, []);

    useEffect(() => {
        loadHistory(currentPage);
    }, [currentPage]);

    const loadDashboard = async () => {
        try {
            const data = await getColdOutreachDashboard();
            setDashboard(data);
        } catch (err) {
            console.error(err);
        }
    };

    const loadHistory = async (page = 1) => {
        try {
            const data = await getColdOutreachHistory(page, 10);
            setHistory(data);
        } catch (err) {
            console.log(err);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-screen-xl mx-auto px-6 py-8 space-y-6">

                {/* Page Header */}
                <div className="flex items-center justify-between">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
                            Cold Outreach Analytics
                        </h1>
                        <p className="text-sm text-gray-500 mt-0.5">
                            Track campaign performance, delivery rates, and engagement trends
                        </p>
                    </div>
                </div>

                {/* Stats Overview */}
                <DashboardStats dashboard={dashboard} />

                {/* Latest Campaign */}
                <LatestCampaignCard campaign={dashboard?.latest_campaign} />

                {/* Top Analytics Lists */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                    <AnalyticsListCard
                        title="Top Segments"
                        items={dashboard?.top_segments || []}
                        labelKey="targeted_segment"
                        valueKey="campaigns"
                    />
                    <AnalyticsListCard
                        title="Top Categories"
                        items={dashboard?.top_categories || []}
                        labelKey="name"
                        valueKey="campaigns"
                    />
                    <AnalyticsListCard
                        title="Top Subcategories"
                        items={dashboard?.top_subcategories || []}
                        labelKey="name"
                        valueKey="campaigns"
                    />
                </div>

                {/* Charts */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    <CampaignTrendChart data={dashboard?.campaign_trend || []} />
                    <SuccessFailureChart
                        success={dashboard?.success_emails || 0}
                        failed={dashboard?.failed_emails || 0}
                    />
                </div>

                {/* History Table */}
                <HistoryTable
                    history={history}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />

            </div>
        </div>
    );
};

export default ColdOutreachAnalytics;